// @flow
import { gql, useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { ErrorPage, Footer } from "@nested/brand";
import { NotFound } from "@nested/brand/src/pages/NotFound";
import { Loading } from "@nested/onboarding-form/src/OnboardingForm";
import { Hero } from "./Hero";
import { ComparisonTable } from "./ComparisonTable";
import { BookCallSection } from "./BookCallSection";
import { FloatingCta } from "./FloatingCta";

const AVM_QUERY = gql`
  query AVMResult($id: ID!) {
    avmValuationResult(id: $id) {
      id
      minPrice
      maxPrice
      property {
        id
        postcode
        formattedAddress
        lat
        lng
        relationshipManager {
          id
          firstName
          email
        }
      }
    }
  }
`;

export const AVMValuationResult = () => {
  const { id } = useParams();
  const { data, loading, error } = useQuery(AVM_QUERY, {
    variables: { id },
    skip: !id,
  });

  if (!id) {
    return (
      <>
        <NotFound />
        <Footer />
      </>
    );
  }

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorPage />;
  }

  if (!data?.avmValuationResult) {
    return (
      <>
        <NotFound />
        <Footer />
      </>
    );
  }

  const {
    minPrice,
    maxPrice,
    property: { formattedAddress, lat, lng, relationshipManager },
  } = data.avmValuationResult;

  return (
    <>
      <Hero
        address={formattedAddress}
        min={minPrice}
        max={maxPrice}
        lat={parseFloat(lat)}
        lng={parseFloat(lng)}
      />
      <ComparisonTable />
      <BookCallSection
        rmFirstName={relationshipManager?.firstName}
        rmEmail={relationshipManager?.email}
      />
      <Footer />
      <FloatingCta />
    </>
  );
};
